import { memo, useEffect } from "react";
import { useMiningStore } from "../../../../Store/miningStore";
import { MiningService } from "../../services/MiningService";
import MiningCard from "../MiningCard/MiningCard";
import BoostButton from "../BoostButton/BoostButton";
import styles from "./MiningBar.module.css";
import { useCPMallowedStore } from "../../../../Store/CPMallowedStore";

const MiningBar = memo(() => {
  const setMiningData = useMiningStore((state) => state.setMiningData);
  const miningData = useMiningStore((state) => state.miningData);

  const setCPMallowed = useCPMallowedStore((state) => state.setCPMallowed);

  useEffect(() => {
    const fetchMiningStatus = async () => {
      try {
        const data = await MiningService.fetchMiningData();
        setMiningData(data);
        setCPMallowed(data.cpm_banners_allowed);
      } catch (error) {
        console.error("Ошибка при получении статуса майнинга:", error);
      }
    };

    fetchMiningStatus();
  }, [setMiningData]);

  const handleBoost = async () => {
    if (!miningData) return;
    await MiningService.boostMining(miningData.mining.id);
  };

  return (
    <div className={styles.miningContainer}>
      <MiningCard />
      <div className={styles.boostButtonContainer}>
        <BoostButton onClick={handleBoost} />
      </div>
    </div>
  );
});

MiningBar.displayName = "MiningBar";

export default MiningBar;
